module.exports = __webpack_public_path__ + "static/elipageblack-d2a2ed0e12b898d8750fddd3f5f349d0.png";